import { drilldownDataCorporate, ModuleFields } from "~/Utils/drilldownDataDum";

const mapFields = (data: ModuleFields[]) => {
  return data.map(({ fieldName, placeholder, name, formType, validation, className, hidden, dynamicFormType, rowConfig, usedFileType }) => {
    return {
      name,
      type: formType,
      label: fieldName,
      placeholder,
      validation,
      className,
      hidden,
      dynamicFormType,
      usedFileType
    };
  });
};


let fields: any = {};

const fieldsReady = new Promise(async (resolve, reject) => {
  try {
    const data = await drilldownDataCorporate();
    fields = {
      airportsPageHeading: mapFields(data?.airportsPageHeading || []),
      corporatePageHeading: mapFields(data?.corporatePageHeading || []),
      corporatePageContent: mapFields(data?.corporatePageContent || []),
      corporateNextPage: mapFields(data?.corporateNextPage || []),
      corporateMap: mapFields(data?.corporateMap || []),
      corporateAddress: mapFields(data?.corporateAddress || []),
      corporateCommunication: mapFields(data?.corporateCommunication || [])
    };
    resolve(fields); 
  } catch (error) {
    console.error("Error accessing drilldown data:", error);
    reject(error); 
  }
});

export { fields, fieldsReady };
